export default "__VITE_ASSET__0e9HUtfE__"